// extracted by mini-css-extract-plugin
export default {"seatsCountSelector":"SeatsCountSelector_seatsCountSelector__qsHBo","seatsCount":"SeatsCountSelector_seatsCount__nqVCz"};